var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockIcon = function SvgLockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.999 0a9.31 9.31 0 0 0-9.312 9.312v3.932H0v15.794A2.96 2.96 0 0 0 2.962 32h18.076A2.96 2.96 0 0 0 24 29.038V13.244h-2.69V9.312A9.31 9.31 0 0 0 12 0m7.83 13.244V9.312a7.831 7.831 0 0 0-15.661 0v3.932zm-6.97 9.245c.997-.323 1.711-1.19 1.711-2.21 0-1.296-1.151-2.346-2.571-2.346s-2.572 1.05-2.572 2.345c0 1.022.717 1.891 1.717 2.213v3.258h1.714z",
    clipRule: "evenodd"
  })));
};
export default SvgLockIcon;